//
//
//
//

export default {
data() {
return {}
},
methods: {},
mounted() {},
created() {},
props:{},
watch:{ },
components:{}
}



// WEBPACK FOOTER //
// ./src/views/contactUs/contactUs.vue